import React from 'react';
import { Navigate, Route, BrowserRouter as Router, Routes } from 'react-router-dom';
import { AuthProvider, useAuth } from './contexts/AuthContext';
import './App.css';
import Layout from './components/Layout/Layout';
import CreatePatient from './pages/CreatePatient/CreatePatient';
import CreditPurchases from './pages/CreditPurchases/CreditPurchases';
import Dashboard from './pages/Dashboard/Dashboard';
import ExcelUpload from './pages/ExcelUpload/ExcelUpload';
import Login from './pages/Login/Login';
import PatientRegister from './pages/PatientRegister/PatientRegister';
import PurchasesExpenses from './pages/PurchasesExpenses/PurchasesExpenses';
import Reports from './pages/Reports/Reports';
import SalesEntry from './pages/SalesEntry/SalesEntry';
import Settings from './pages/Settings/Settings';
import Users from './pages/Users/Users';

// Protected Route Component
const ProtectedRoute = ({ children }) => {
  const { isAuthenticated, isLoading } = useAuth();

  if (isLoading) {
    return <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100vh' }}>Loading...</div>;
  }

  return isAuthenticated ? children : <Navigate to="/login" />;
};

function App() {
  return (
    <AuthProvider>
      <Router>
        <Routes>
          <Route path="/login" element={<Login />} />
          <Route
            path="/"
            element={
              <ProtectedRoute>
                <Layout />
              </ProtectedRoute>
            }
          >
            <Route index element={<Navigate to="/dashboard" />} />
            <Route path="dashboard" element={<Dashboard />} />
            <Route path="sales-entry" element={<SalesEntry />} />
            <Route path="purchases-expenses" element={<PurchasesExpenses />} />
            <Route path="credit-purchases" element={<CreditPurchases />} />
            <Route path="patient-register" element={<PatientRegister />} />
            <Route path="create-patient" element={<CreatePatient />} />
            <Route path="reports" element={<Reports />} />
            <Route path="excel-upload" element={<ExcelUpload />} />
            <Route path="settings" element={<Settings />} />
            <Route path="users" element={<Users />} />
          </Route>
        </Routes>
      </Router>
    </AuthProvider>
  );
}

export default App;
